<ul aria-labelledby="tree-label" role="tree" class="tree-menu__block text-14">
  <li class="tree-menu__item-container" *ngFor="let node of nodes">
    <div
      [attr.aria-expanded]="node.isOpen"
      aria-posinset="0"
      aria-setsize="2"
      role="treeitem"
      tabindex="0"
      class="tree-menu__item flex flex--row"
      [class.tree-menu__item--selected]="selectedNode === node"
    >
      <div *ngIf="pinnedIcon" [id]="'tree-node-pin-' + node.id">
        <div>
          <svg-icon
            name="ico-pin-16"
            class="pinned icons-hover"
            [ngClass]="{ not: !node.isPinned}"
            [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
            [ngStyle]="{ 'height': '16px', 'padding-right': '10px' }"
            (click)="pinSavedWorkList(node)"
          >
          </svg-icon>
         </div>
      </div>
      <div *ngIf="node.isOpen && node.children && node.children.length" [id]="'tree-node-caret-down-' + node.id">
        <svg-icon
          name="ico-caret-down-16"
          class="tree-menu__icon"
          [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
          [ngStyle]="{ height: '16px' }"
          (click)="close(node)"
        >
        </svg-icon>
      </div>

      <div *ngIf="!node.isOpen && node.children && node.children.length" [id]="'tree-node-caret-right-' + node.id">
        <svg-icon
          name="ico-caret-right-16"
          class="tree-menu__icon"
          [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
          [ngStyle]="{ height: '16px' }"
          (click)="open(node)"
        >
        </svg-icon>
      </div>

      <div
        class="flex--item--zero flex flex--row"
        (click)="select(node)"
        [class.tree-after-caret]="alignAfterCaret && (!node.children || node.children.length <= 0)"
      >
        <div *ngIf="showIcons && node.icon">
          <svg-icon
            [name]="node.icon"
            class="tree-menu__icon--inline"
            [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
            [ngStyle]="{ height: '16px' }"
          >
          </svg-icon>
        </div>

        <div class="flex flex--row flex--nowrap flex--left flex--middle flex--item--zero">
          <div
            [id]="'tree-node-' + node.id"
            class="tree-menu__item-name text-ellipsis"
            [tooltip]="node.tooltip || node.name"
            tooltipWidth="182px"
            [overflowOnly]="true"
            position="top"
            style="flex-grow: 1">
            {{ node.name }}
          </div>

          <!-- Filter indicator -->
          <div *ngIf="node.isFiltered" [id]="'tree-node-filtered-' + node.id">
            <svg-icon
              name="ico-filter-16"
              class="tree-menu__icon--inline"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
              [ngStyle]="{ height: '16px' }"
            >
            </svg-icon>
          </div>

          <!-- AI Findings indicator-->
          <div
            *ngIf="findingsEnabled && node.count?.findings > 0"
            [id]="'tree-node-ai-findings-' + node.id"
          >
            <svg-icon
              name="ico-ai-16"
              class="tree-menu__icon--inline"
              [svgStyle]="{ 'height.px': '16', 'width.px': '16' }"
              [ngStyle]="{ height: '16px' }"
            >
            </svg-icon>
          </div>

          <!-- Count Container-->
          <div
            class="count-container"
            [id]="'tree-node-count-' + node.id"
            *ngIf="node.count && !node.count.isUnmonitored"
          >
            <wfm-to-do-count [counts]="node.count" [showFindings]="false"></wfm-to-do-count>
          </div>

          <div class="tree-menu__icon-operation-trigger">
            <wfm-dropdown *ngIf="dropdownOperations && operations && operations.length && node.operations && node.operations.length"
                          [adjustVerticalOverflow]="true"
                          [(isOpen)]="node.isDropdownOpen"
                          (click)="$event.stopPropagation()"
                          defaultPosition="right">
              <div slot="trigger" class="clickable" style="height: 1.4rem">
                <svg-icon
                  name="ico-more-vertical-16"
                  [svgStyle]="{ 'width.px': '14', 'height.px': '14', 'fill': 'currentColor' }"
                  [ngStyle]="{ height: '1.4rem' }">
                </svg-icon>
              </div>

              <div
                class="text-16 action-items"
                id="tree-menu-operations-container"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()">
                <div *ngFor="let op of operations | treeOperationFilter: node.operations"
                  id="{{ op.id }}"
                  class="clickable selectable u-p--- flex"
                  (click)="node.isDropdownOpen = false; perform(op, node, $event)"
                >
                  <div>
                    <svg-icon
                      [name]="op.icon"
                      [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
                      style="vertical-align: text-top"
                    >
                    </svg-icon>
                  </div>
                  <div class="u-pl---">{{ op.label | translate }}</div>
                </div>
              </div>
            </wfm-dropdown>
          </div>
        </div>
      </div>

      <div
        class="tree-menu__item-operations"
        *ngIf="!dropdownOperations && operations && operations.length && node.operations && node.operations.length">
        <span
          *ngFor="let op of operations | treeOperationFilter: node.operations"
          (click)="perform(op, node, $event)"
          [tooltip]="op.label | translate"
          position="left"
          class="tree-menu__icon-operation">
          <svg-icon
            [name]="op.icon"
            class="tree-menu__icon--inline"
            [svgStyle]="{ 'width.px': '14', 'height.px': '14', 'fill': 'currentColor' }"
            [ngStyle]="{ height: '14px' }">
          </svg-icon>
        </span>
      </div>
    </div>

    <wfm-tree
      *ngIf="node.isOpen && node.children && node.children.length"
      [nodes]="node.children"
      [showIcons]="showIcons"
      [selectedNode]="selectedNode"
      [operations]="operations"
      [alignAfterCaret]="alignAfterCaret"
      (selectedNodeChange)="selectChild($event)"
      (nodeOpen)="openChild($event)"
      (nodeClose)="closeChild($event)"
      (performOperation)="performOperationChild($event)"
      [dropdownOperations]="dropdownOperations"
      (selectPin)="pinChild($event)"
      [pinnedIcon]="pinnedIcon"
    >
    </wfm-tree>
  </li>
</ul>
